var SctAccordion = /** @class */ (function () {
    function SctAccordion() {
        var _this = this;
        this.title = document.querySelectorAll('.accordion-title');
        var _loop_1 = function (i) {
            this_1.title[i].addEventListener('click', function () {
                _this.toggle(_this.title[i]);
            });
        };
        var this_1 = this;
        for (var i = 0; i < this.title.length; i = i + 1) {
            _loop_1(i);
        }
    }
    SctAccordion.prototype.toggle = function (eleme) {
        if (eleme !== null) {
            var content = eleme.nextElementSibling;
            eleme.classList.toggle('is-active');
            content.classList.toggle('is-open');
        }
    };
    return SctAccordion;
}());
export { SctAccordion };
